// addEventListener support for IE8
function bindEvent(element, eventName, eventHandler) {
    if (element.addEventListener) {
        element.addEventListener(eventName, eventHandler, false);
    } else if (element.attachEvent) {
        element.attachEvent('on' + eventName, eventHandler);
    }
}

// Send a message to the parent
function sendMessageToParent(msg) {
    // Make sure you are sending a string, and to stringify JSON
    // window.parent.postMessage(msg, `${config.domain_name}`);
    // let url = new URL(document.referrer);
    // let target = url.protocol + "//" + url.host;
    window.parent.postMessage(msg, "*");
};

export { bindEvent, sendMessageToParent }
